module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/minimize-deb9096427b2cdebf78fe9964fc385a0.svg";